import { Dispatch } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';

import type { AppDispatch } from 'src/store/types';

/**
 * Hooks for dispatching synchronous actions
 */
export const useAppDispatch = (): Dispatch<any> => useDispatch<AppDispatch>();
